import { IAbstractRecord } from '@models';
import { isEmpty } from '@utils/validationUtils';
import {
  IPaymentDetailsResponse,
  ITransactionTableData,
  IVoucherPopupTableData,
} from './types';
import FormattingService from '@services/FormattingService';

export const mapToPaymentDetails = (data: IPaymentDetailsResponse) => {
  if (isEmpty(data)) {
    return null;
  }

  const singlePaymentRecord = data.GetPayment[0];
  const singleTransactionRecord = data.GetPaymentTransactionDetails[0];

  const payments: Record<string, IVoucherPopupTableData> = {};
  data.GetPayment.forEach((payment, index: number) => {
    const billType = payment.parentBill_ParentBillCategory;
    const policyName = payment.policyDetails_PolicyNumber;
    const certificateNumber = payment.policyDetails_CertificateNumber;
    const policyType = payment.policyDetails_Type;

    payments[index] = {
      tableId: index,
      policyId: payment.policyDetails_PolicyNumber,
      reference:
        billType === 'PRODUCTION'
          ? policyType === 'CERTIFICATE'
            ? `${policyName} ${certificateNumber}`
            : `${policyName}`
          : policyType === 'CERTIFICATE'
            ? `${policyName} ${certificateNumber} ${payment.linkedAmendment_AmendmentNumber} ${payment.linkedAmendment_AmendmentLineNumber}`
            : `${policyName} ${payment.linkedAmendment_AmendmentNumber} ${payment.linkedAmendment_AmendmentLineNumber}`,
      billId: payment.billDetails_Id,
      billNum: payment.billDetails_BillNumber,
      dueDate: payment.billDetails_DueDate,
      amountDue: payment.billDetails_AmountDue,
      amountOutstanding: payment.paymentDetails_AmountOutstanding,
      amountOutstandingCurrency:
        payment.paymentDetails_AmountOutstandingCurrency,
      amount: payment.paymentDetails_AmountReceived,
      Currency: payment.billDetails_Currency.Symbol,
    };
  });

  const transactions: ITransactionTableData[] = [];
  data.GetPaymentTransactionDetails.forEach((transaction) => {
    transactions.push({
      transactionId: transaction.transactionDetails_Id,
      accountId:
        transaction.transactionDetails_RelatedAccount?.views?.Accounting_all
          ?.properties?.AccountID,
      accountName:
        transaction.transactionDetails_RelatedAccount?.views?.Accounting_all
          ?.properties?.AccountName,
      accountNameDisabled: true,
      description: transaction.transactionDetails_Description,
      descriptionDisabled: true,
      accountCredit: transaction.transactionDetails_AccountCredit,
      accountDebit: transaction.transactionDetails_AccountDebit,
      systemCredit: transaction.transactionDetails_SystemCredit,
      systemDebit: transaction.transactionDetails_SystemDebit,
      systemSecondaryDebit: transaction.transactionDetails_SystemSecondaryDebit,
      systemSecondaryCredit:
        transaction.transactionDetails_SystemSecondaryCredit,
      transactionCurrency:
        transaction.transactionDetails_RelatedAccount?.views?.Accounting_all
          ?.properties?.AccountCurrency?.Code,
    });
  });

  // Construct final result using the initial record's shared details
  return {
    paymentId: singlePaymentRecord.accounting_Payments_Id,
    dateOfPayment: singlePaymentRecord.accounting_Payments_PaymentDate,
    currency: singlePaymentRecord.accounting_Payments_PaymentCurrency,
    paymentMethod: singlePaymentRecord.accounting_Payments_PaymentMethod,
    referenceNum: singlePaymentRecord.accounting_Payments_ReferenceNo,
    totalAmount: singlePaymentRecord.accounting_Payments_TotalAmountReceived,
    totalAmountUnAllocated: 0,
    totalCredit: singleTransactionRecord.transaction_TotalSystemCredit,
    totalDebit: singleTransactionRecord.transaction_TotalSystemDebit,
    incomingDocuments:
      singlePaymentRecord.accounting_Payments_PaymentDocuments ?? [],
    note: singlePaymentRecord.accounting_Payments_Note,
    payments,
    transactions,
  };
};

export const mapNotesList = (data: IAbstractRecord) => {
  if (!data) {
    return {};
  }
  const list: IAbstractRecord = {};

  data.forEach((note: IAbstractRecord) => {
    list[note.accounting_Notes_Id] = {
      reference: note.accounting_Notes_Reference,
      policy:
        note.linkedAmendment_PolicyID?.views?.Production_all?.properties
          ?.PolicyNumber,
      amount: note.accounting_Notes_Amount,
      amountOutstanding: note.accounting_Notes_AmountOutstanding,
      status: FormattingService.formatEnumToDisplay(
        note.accounting_Notes_Status
      ),
      modifiedBy: note.accounting_Notes_ModifiedByText,
      Currency: note.billDetails_Currency?.Symbol,
    };
  });

  return list;
};
